module.exports = __webpack_public_path__ + "static/media/asiance-logo.f411e222.svg";